<template>
  <div class="user_pages_header">
    <img
      class="background_img"
      src="@/assets/img/public/userpage-header.svg"
      alt="user page header"
    />
    <div class="page_icon">
      <transition name="rightout">
        <img
          v-if="icon == 'cart'"
          src="@/assets/img/public/userpage-header-icon/cart.svg"
          alt=""
        />
      </transition>
      <transition name="rightout">
        <img
          v-if="icon == 'orders'"
          src="@/assets/img/public/userpage-header-icon/orders.svg"
          alt=""
        />
      </transition>
      <transition name="rightout">
        <img
          v-if="icon == 'register'"
          src="@/assets/img/public/userpage-header-icon/register.svg"
          alt=""
        />
      </transition>
      <transition name="rightout">
        <img
          v-if="icon == 'login'"
          src="@/assets/img/public/userpage-header-icon/login.svg"
          alt=""
        />
      </transition>
      <transition name="rightout">
        <img
          v-if="icon == 'profile'"
          src="@/assets/img/public/userpage-header-icon/profile.svg"
          alt=""
        />
      </transition>
      <transition name="rightout">
        <img
          v-if="icon == 'sms'"
          src="@/assets/img/public/userpage-header-icon/sms.svg"
          alt=""
        />
      </transition>
      <transition name="rightout">
        <img
          v-if="icon == 'change-password'"
          src="@/assets/img/public/userpage-header-icon/change-password.svg"
          alt=""
        />
      </transition>
    </div>
    <h1 v-if="title" class="title">{{ title }}</h1>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "userPagesHeader",
  props: {
    title: String,
    icon: {
      type: String,
      default: "",
    },
  },
  methods: {
    ...mapMutations({
      setManagerMode: "setManagerMode",
    }),
  },
};
</script>
<style lang="css" scoped>
@import url(@/assets/style/components/userPagesHeader/userPagesHeader.css);
</style>
